<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { Menu } from '@fibl/oxs-common';
import { EAV } from '@fibl/zdb-common';
import SearchMenuDropdownBranch from '@/components/layout/menu/search-menu-dropdown-branch.vue';

type Ent = EAV.Entity<Menu.Menu>;

export default defineComponent({
	name: 'SearchMenuDropDownItem',

	props: {
		routeToRequest: {
			type: Boolean,
		},
		item: {
			type: Object as PropType<Ent>,
		},
		mode: {
			type: String as PropType<'dropdown' | 'inline'>,
			default: 'dropdown',
		},
	},

	components: { SearchMenuDropdownBranch },

	data: () => ({
		activeMenuId: '',
		activeMenuName: '',
	}),

	computed: {
		fullMenu(): Ent[] {
			return this.$globalStore.menuStore.menus;
		},
		requestEnabled() {
			return (
				this.$globalStore.websiteStore.getOxsCountrySettings.hasRequestProcess &&
				['agr', 'ins', 'aut', 'con'].includes(this.$globalStore.tokenStore.role) &&
				this.$globalStore.offerSearchStore.menuSearchSettings.availableRequestTypes.length >
					0
			);
		},
		rootItems() {
			return this.fullMenu
				.filter((e) => !e.data.parent)
				.sort((a, b) => a.data.sorting - b.data.sorting);
		},
		website() {
			return this.$globalStore.websiteStore.websiteCode;
		},
		countryCode() {
			return this.$globalStore.websiteStore.countryCode;
		},
	},

	emits: ['selected-menu'],

	methods: {
		onSetActive(selectedEntry: EAV.Entity<Menu.Menu>) {
			this.activeMenuId = selectedEntry.id;
			this.activeMenuName = this.$filters.toLocale(selectedEntry.data.labels);
			this.$emit('selected-menu', selectedEntry);
		},
	},

	async mounted() {
		await this.$globalStore.menuStore.loadForWebsite();
	},
});
</script>

<template>
	<div>
		<div>
			<template v-if="!item">
				<SearchMenuDropdownBranch
					v-for="entry in rootItems"
					:key="entry.id"
					:entry="entry"
					:route-to-request="routeToRequest"
					:mode="mode"
					:active-menu-id="activeMenuId"
					@set-active="onSetActive"
				/>
			</template>
			<template v-else>
				<SearchMenuDropdownBranch
					:entry="item"
					:route-to-request="routeToRequest"
					:active-menu-id="activeMenuId"
					@set-active="onSetActive"
				/>
			</template>
		</div>
		<div v-if="activeMenuName">{{ $t('components.menu.menu') }}: {{ activeMenuName }}</div>
	</div>
</template>
